export const form = {
  formCopyLink: 'Kopírovat odkaz',
  formLinkCopied: 'Odkaz zkopírován!'
}
